import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ToastComponent } from './toast.component';
import { MessageBoxType } from './models';
import { MatSnackBar, MatSnackBarDismiss, MatSnackBarRef } from '@angular/material/snack-bar';

@Injectable()
export class ToastService {
  private snackBarRef!: MatSnackBarRef<any>;

  constructor(private snackBar: MatSnackBar) {}

  public show(
    title: string | null,
    text: string,
    type: MessageBoxType,
    duration: number = 8000,
    callBackButtonLabel?: string,
    callBack?: () => any,
    withTranslations = true
  ) {
    this.snackBarRef = this.snackBar.openFromComponent(ToastComponent, {
      horizontalPosition: 'end',
      verticalPosition: 'top',
      data: {
        title,
        text,
        type,
        callBackButtonLabel,
        callBack,
        withTranslations,
      },
      duration: duration,
    });
  }

  public dismissed(): Observable<MatSnackBarDismiss> {
    return this.snackBarRef?.afterDismissed();
  }
}
